<template>
  <LoginButton :isModalVisible="true" buttonClass="hidden" :email="email" :returnUrl="returnUrl" text="" @close="close" />
</template>

<script>
import LoginButton from '@/account/components/LoginButton.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Login',
  components: {
    LoginButton,
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    email() {
      return this.$route.query.email;
    },
    returnUrl() {
      return this.$route.query.returnUrl || '/';
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'authSuccess') {
        if (this.$route.query.returnUrl) {
          this.$router.replace(decodeURIComponent(this.$route.query.returnUrl));
        } else {
          this.$router.replace('/');
        }
      }
    });
    if (this.isLoggedIn) {
      this.$router.replace('/');
    }
  },
  methods: {
    close() {
      this.$router.replace('/');
    },
  },
  beforeUnmount() {
    this.unsubscribe();
  },
};
</script>
